module.exports = __webpack_public_path__ + "img/icon-core3-1.c8447707.png";